<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons" style="font-size: 40px">receipt</i>
        </div>
        <h4 class="card-title">Invoice</h4>
      </div>

      <div class="card-body">
        <div *ngIf="loading" class="row" style="text-align: center">
          <div class="col-12">
            <h2>
              <b
                ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                Loading...</b
              >
            </h2>
          </div>
        </div>

        <form *ngIf="!loading">
          <div *ngIf="tab !== null">

            <div class="row bloque mi">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>invoice #</b></label>
                          <input
                            type="text"
                            name="invoicenumber"
                            [(ngModel)]="invoice.invoice"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Arinvoice detailid</b></label>
                          <input
                            type="text"
                            name="invoicearinvoicedetailid"
                            [(ngModel)]="invoice.arinvoicedetailid"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Account</b></label>
                          <input
                            type="text"
                            name="invoiceaccount"
                            [(ngModel)]="invoice.account"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Early invoice</b></label>
                          <input
                            type="text"
                            name="invoiceearlyinvoice"
                            [(ngModel)]="invoice.earlyinvoice"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <div class="row">

                  <div class="col-md-12">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Description</b></label>
                          <input
                            type="text"
                            name="invoicedescription"
                            [(ngModel)]="invoice.description"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-12">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Extended description</b></label>
                          <textarea
                            name="invoiceextendeddescription"
                            [(ngModel)]="invoice.extendeddescription"
                            class="form-control fctrl"
                            cols="30"
                            rows="3"
                            [disabled]="!edit"
                          ></textarea>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

                <h4 class="card-title title">
                  <b>Billto Contact</b>
                </h4>

                <div class="row">

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Name</b></label>
                          <input
                            type="text"
                            name="billtocontactname"
                            [(ngModel)]="invoice.billtocontactname"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Phone</b></label>
                          <input
                            type="text"
                            name="billtocontactphone"
                            [(ngModel)]="invoice.billtocontactphone"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Email</b></label>
                          <input
                            type="text"
                            name="billtoemail"
                            [(ngModel)]="invoice.billtoemail"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Fax</b></label>
                          <input
                            type="text"
                            name="billtocontactfax"
                            [(ngModel)]="invoice.billtocontactfax"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
            <div class="row bloque mi">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <!-- <h3 class="card-title title">
                      <b>SO# {{ so.so }}</b>
                      <b style="color: red" *ngIf="so.status === 'Voided'">
                        Voided
                      </b>
                    </h3> -->
                  </div>
                  <div class="col-md-6" style="text-align: right">
                    <!-- <button
                      style="width: 100px"
                      class="btn btn-sm btn-outline-danger"
                      (click)="pdf()"
                    >
                      <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                      &nbsp; PDF
                    </button> -->
                    &nbsp;
                    <!-- <button
                      *ngIf="so.status === 'Voided'"
                      style="width: 100px"
                      class="btn btn-sm btn-danger"
                      disabled
                    >
                      <span class="material-icons">content_paste_off</span>
                      &nbsp; Voided
                    </button> -->
                    <!-- <button
                      *ngIf="so.status !== 'Voided'"
                      style="width: 100px"
                      class="btn btn-sm btn-danger"
                      [disabled]="cancelando || !edit"
                      (click)="voidpp()"
                    >
                      <i
                        *ngIf="cancelando"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i>
                      <span *ngIf="!cancelando" class="material-icons"
                        >content_paste_off</span
                      >
                      &nbsp; Void
                    </button> -->

                    &nbsp;

                    <!-- <button
                      style="width: 100px"
                      class="btn btn-sm btn-info"
                      (click)="sendMail()"
                    >
                      <span class="material-icons">mail</span>
                      &nbsp; Email
                    </button> -->
                  </div>
                </div>

                <div class="row">
                  <div
                    style="border-right-style: groove; padding-right: 20px"
                    class="col-md-3"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Date</b></label>
                          <input
                            type="date"
                            name="date"
                            [(ngModel)]="so.date"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Client Po Number</b></label>
                          <input
                            type="text"
                            name="clientPoNumber"
                            [(ngModel)]="so.clientPoNumber"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Selling Terms</b></label>
                          <select
                            name="terms"
                            [(ngModel)]="so.term"
                            class="form-control fctrl"
                            [disabled]="!edit"
                            required
                          >
                            <option
                              *ngFor="let term of netTerms"
                              [value]="term.id"
                            >
                              {{ term.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Condition</b></label>
                          <select
                            name="conditions"
                            [(ngModel)]="so.conditions_id"
                            class="form-control fctrl"
                            [disabled]="!edit"
                            required
                          >
                            <option
                              *ngFor="let item of conditions"
                              [value]="item.id"
                            >
                              {{ item.name }} - {{ item.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Rep</b></label>
                          <select
                            name="representative"
                            [(ngModel)]="so.rep_id"
                            class="form-control fctrl"
                            [disabled]="!edit"
                            required
                          >
                            <option [value]="4">Admin Admin</option>
                            <option
                              *ngFor="let rep of repsList"
                              [value]="rep.id"
                            >
                              {{ rep.name }} {{ rep.surname }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="border-right-style: groove; padding-right: 20px"
                    class="col-md-3"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Currency</b></label>
                          <select
                            name="currency"
                            [(ngModel)]="so.currency"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          >
                            <option
                              *ngFor="let item of currencies"
                              [value]="item.name"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Promise Date</b></label>
                          <input
                            type="date"
                            name="promiseDate"
                            [(ngModel)]="so.promiseDate"
                            class="form-control fctrl"
                            [disabled]="!edit"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                >Void After</label
                              >
                              <input
                                type="date"
                                name="voidafter"
                                [(ngModel)]="so.voidafter"
                                class="form-control fctrl"
                                [disabled]="!edit"
                              />
                            </div>
                          </div>
                        </div> -->

                    <!-- <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                >Probability Factor</label
                              >
                              <span class="bmd-form-group">
                                <div class="input-group">
                                  <input
                                    type="number"
                                    name="probabilityfactor"
                                    maxlength="6"
                                    [(ngModel)]="so.probabilityFactor"
                                    class="form-control fctrl"
                                    style="text-align: right"
                                    [disabled]="!edit"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i
                                        class="fa fa-percent"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                        </div> -->
                  </div>

                  <div
                    style="border-right-style: groove; padding-right: 20px"
                    class="col-md-3"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Customer</b></label>
                          <span class="bmd-form-group">
                            <div class="input-group">
                              <input
                                type="txt"
                                name="customerName"
                                [(ngModel)]="so.customerName"
                                class="form-control fctrl"
                                disabled
                              />
                              <div class="input-group-prepend" *ngIf="edit">
                                <span class="input-group-text">
                                  <button
                                    class="btn btn-warning btn-sm"
                                    (click)="changeCustomer()"
                                  >
                                    <i
                                      class="fa fa-random"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>SP Number</b></label>
                          <input
                            type="text"
                            name="ppnum"
                            [(ngModel)]="so.sp"
                            class="form-control fctrl"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>SO Number</b></label>
                          <input
                            type="text"
                            name="ponum"
                            [(ngModel)]="so.so"
                            class="form-control fctrl"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Status</b></label>
                          <input
                            type="text"
                            name="status"
                            [(ngModel)]="so.status"
                            class="form-control fctrl"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-10">
                        <label
                          class="{{ edit ? 'checkbox' : 'checkdisabled' }}"
                          (click)="checkHideLine()"
                        >
                          <span class="material-icons"
                            >{{
                              so.hideline === 1
                                ? "check_box"
                                : "check_box_outline_blank"
                            }}
                          </span>
                          &nbsp; <strong>Hide Line</strong></label
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                ><b>Extend Cost</b></label
                              >
                              <input
                                type="number"
                                name="extendCost"
                                [(ngModel)]="so.extendedcost"
                                class="form-control fctrl"
                                disabled
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"><b>Freight</b></label>
                              <input
                                type="number"
                                name="freight"
                                [(ngModel)]="so.freight"
                                (change)="save()"
                                class="form-control fctrl"
                                [disabled]="!edit"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                ><b>Extra Cost</b></label
                              >
                              <input
                                type="number"
                                name="extracost"
                                [(ngModel)]="so.extracost"
                                (change)="save()"
                                class="form-control fctrl"
                                [disabled]="!edit"
                                (keyup)="
                                  so.extracost = mtds.fixed(so.extracost, 2)
                                "
                                (focusout)="
                                  so.extracost = mtds.fixed(so.extracost, 2)
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"><b>Tax</b></label>
                              <input
                                type="number"
                                name="tax"
                                [(ngModel)]="so.tax"
                                class="form-control fctrl"
                                disabled
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                ><b>Sub Total</b></label
                              >
                              <input
                                type="number"
                                name="subtotal"
                                [value]="subTotal()"
                                class="form-control fctrl"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <!-- <div class="row">
                              <div class="col-md-12">
                                <button
                                  style="margin-top: 27px"
                                  class="btn btn-sm btn-block {{
                                    so.so === null
                                      ? 'btn-warning'
                                      : 'btn-info'
                                  }}"
                                  (click)="
                                    so.so === null ? makeSo() : gotoSo()
                                  "
                                >
                                  <i
                                    *ngIf="so.so === null"
                                    class="fa fa-shopping-cart"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    *ngIf="so.so !== null"
                                    class="fa fa-eye"
                                    aria-hidden="true"
                                  ></i>
                                  &nbsp;
                                  {{
                                    so.so === null
                                      ? "Make PO"
                                      : "Go to PO"
                                  }}
                                </button>
                              </div>
                            </div> -->

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"><b>Services</b></label>
                              <input
                                type="number"
                                name="servichesCharge"
                                [(ngModel)]="so.servichesCharge"
                                class="form-control fctrl"
                                (change)="save()"
                                [disabled]="!edit"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                ><b>Misc. Charge</b></label
                              >
                              <input
                                type="number"
                                name="misCcharge"
                                [(ngModel)]="so.misCcharge"
                                (change)="save()"
                                class="form-control fctrl"
                                [disabled]="!edit"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"><b>Margin</b></label>
                              <span class="bmd-form-group">
                                <div class="input-group">
                                  <input
                                    type="number"
                                    name="marginPercentage"
                                    maxlength="6"
                                    [(ngModel)]="so.marginPercentage"
                                    (change)="save()"
                                    class="form-control fctrl"
                                    style="text-align: right"
                                    [disabled]="!edit"
                                  />
                                  <div class="input-group-prepend">
                                    <span class="input-group-text">
                                      <i
                                        class="fa fa-percent"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"
                                ><b>Gross Margin:</b></label
                              >
                              <input
                                type="number"
                                name="grossMargin"
                                [(ngModel)]="so.grossMargin"
                                (change)="save()"
                                class="form-control fctrl"
                                [disabled]="!edit"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label class="bmd-label-floating"><b>Total</b></label>
                              <input
                                type="number"
                                name="total"
                                [(ngModel)]="so.total"
                                class="form-control fctrl"
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-12">
                <nav class="nav nav-pills nav-fill">
                  <a
                    class="nav-item nav-link"
                    [ngClass]="{ active: tab === 1, holis: tab !== 1 }"
                    (click)="tab = 1"
                    >Line Items</a
                  >
                  <a
                    class="nav-item nav-link"
                    [ngClass]="{ active: tab === 2, holis: tab !== 2 }"
                    (click)="tab = 2"
                    >Addresses</a
                  >
                  <a
                    class="nav-item nav-link"
                    [ngClass]="{ active: tab === 3, holis: tab !== 3 }"
                    (click)="tab = 3"
                    >Shipping</a
                  >
                  <a
                    class="nav-item nav-link"
                    [ngClass]="{ active: tab === 4, holis: tab !== 4 }"
                    (click)="tab = 4"
                    >Taxes</a
                  >
                  <a
                    class="nav-item nav-link"
                    [ngClass]="{ active: tab === 5, holis: tab !== 5 }"
                    (click)="tab = 5"
                    >Files</a
                  >
                </nav>
              </div>
            </div>
            <br />
            <hr />
          </div>

          <div class="row">
            <div class="col-md-12">
              <div [ngSwitch]="tab">
                <div *ngSwitchCase="1">
                  <app-items
                    [id]="so.id"
                    [so]="so.so"
                    [identity]="identity"
                    [conditions_id]="so.conditions_id"
                    [conditions]="conditions"
                    [edit]="edit"
                    [grossMargin]="so.grossMargin"
                    [subtotal]="so.subtotal"
                    (new_subtotal)="so.subtotal = $event"
                    (new_total)="so.total = $event"
                    (save)="save()"
                    (status)="so.status = $event"
                  ></app-items>
                </div>
                <div *ngSwitchCase="2">
                  <br />
                  <app-addresses
                    [edit]="edit"
                    [so]="so"
                    [locations]="locations"
                    [userLocations]="userLocations"
                  ></app-addresses>
                </div>
                <div *ngSwitchCase="3">
                  <app-shipping [id]="so.id"></app-shipping>
                </div>
                <div *ngSwitchCase="4">
                  <app-taxes
                    [edit]="edit"
                    [proposal_id]="so.id"
                    country="USA"
                    [state_tax]="so.state_tax"
                    (nuevoTax)="so.tax = $event"
                  ></app-taxes>
                </div>
                <div *ngSwitchCase="5">
                  <app-multi-files></app-multi-files>
                </div>

                <div *ngSwitchDefault>
                  <div class="row">
                    <div class="col-12">
                      <label class="bmd-label-floating"><b>Customer</b></label>
                      <app-filter
                        type="alllistforsell"
                        [so]="null"
                        (select)="seleccionarCliente($event)"
                        [sync]="false"
                        plholder="Client name or Company name"
                      ></app-filter>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="tab !== null">
            <br />
            <hr />

            <div class="row">
              <div class="col-md-12">
                <h3>Comments</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating"><b> Internal Comments</b></label>
                  <textarea
                    name="internalcomments"
                    [(ngModel)]="so.internalcomments"
                    class="form-control"
                    cols="30"
                    rows="3"
                    [disabled]="!edit"
                  ></textarea>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating"><b>
                    Comments to customer</b></label
                  >
                  <textarea
                    name="commentstocustomer"
                    [(ngModel)]="so.commentstocustomer"
                    class="form-control"
                    cols="30"
                    rows="3"
                    [disabled]="!edit"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <button class="btn btn-defalt btn-md" routerLink="/invoices">
                <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back to
                list
              </button>
            </div>

            <div class="col-6" style="text-align: right">
              <button
                *ngIf="edit && tab !== null"
                class="btn btn-primary btn-md"
                (click)="save()"
                [disabled]="saving"
              >
                <i
                  *ngIf="!saving"
                  class="fa fa-floppy-o"
                  aria-hidden="true"
                ></i>
                <i
                  *ngIf="saving"
                  class="fa fa-circle-o-notch fa-spin fa-fw"
                ></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="changeCustomer"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <label class="bmd-label-floating"><b>Select Customer</b></label>
              <app-filter
                type="alllistforsell"
                [so]="null"
                (select)="seleccionarCliente($event)"
                [sync]="false"
                plholder="Client name or Company name"
              ></app-filter>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-default btn-md"
            (click)="closeChangeCustomer()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
